import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom"
// import { lazy, Suspense } from "react"


import { CitiesProvider } from "./contexts/CitiesContext"
import { AuthProvider } from "./contexts/FakeAuthContext"
import ProtectedRoute from "./pages/ProtectedRoute"


import Homepage from "./pages/Homepage"
import Product from "./pages/Product"
import Pricing from "./pages/Pricing"
import PageNotFound from "./pages/PageNotFound"
import AppLayout from "./pages/AppLayout"
import Login from "./pages/Login"


// const Homepage = lazy(() => import("./pages/Homepage"))
// const Product = lazy(() => import("./pages/Product"))
// const Pricing = lazy(() => import("./pages/Pricing"))
// const Login = lazy(() => import("./pages/Login"))
// const AppLayout = lazy(() => import("./pages/AppLayout"))
// const PageNotFound = lazy(() => import("./pages/PageNotFound"))

import CityList from "./components/CityList"
import City from "./components/City"
import Form from "./components/Form"
import CountryList from "./components/CountryList"
// import SpinnerFullPage from "./components/SpinnerFullPage"



function App() {
 
  
  return (
    <AuthProvider>
      <CitiesProvider>
    <BrowserRouter>
    {/* <Suspense fallback={<SpinnerFullPage />}> */}
    
  
      
          <Routes>
            <Route path="/" element={<Homepage />} />
            <Route path="product" element={<Product />} />
            <Route path="pricing" element={<Pricing />} />
            <Route path="/login" element={<Login />} />
            <Route path="app" element={<ProtectedRoute>
              <AppLayout />
              </ProtectedRoute>}>
              <Route index element={<Navigate replace to="cities" />} />
              <Route path="cities" element={<CityList />} />
              <Route path="cities/:id" element={<City />} />
              <Route path="countries" element={<CountryList />}  />
              <Route path="form" element={<Form />} />
            </Route>
        
            <Route path="*" element={<PageNotFound />} />
          </Routes>
          {/* </Suspense> */}
    </BrowserRouter>
      </CitiesProvider>
    </AuthProvider>



  )
}

export default App